import { useState } from 'react';

import { resendGiftPassEmail } from '../../api/gift-pass-actions';
import { SimpleModal } from '../shared/SimpleModal';

import { actionErrorMessage, type ResendOption } from './gift-pass-actions-model';

export interface GiftPassResendModalProps {
  passId: string;
  option: ResendOption;
  onClose: () => void;
  onSent: (toEmail: string) => void;
}

export function GiftPassResendModal({ passId, option, onClose, onSent }: GiftPassResendModalProps) {
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const send = async () => {
    if (submitting) return;
    setSubmitting(true);
    setSubmitError(null);
    try {
      const { toEmail } = await resendGiftPassEmail(passId, option.type);
      onSent(toEmail);
    } catch (err) {
      setSubmitError(actionErrorMessage(err, 'Something went wrong and the email was not sent.'));
      setSubmitting(false);
    }
  };

  return (
    <SimpleModal
      open
      onClose={() => {
        if (!submitting) onClose();
      }}
      title={`${option.label}?`}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <p style={{ margin: 0, fontSize: 13, overflowWrap: 'anywhere' }}>
          Send {option.emailName} again to <strong>{option.toEmail}</strong>?
          {option.note && ` ${option.note}`}
        </p>
        {submitError && (
          <p role="alert" style={{ margin: 0, fontSize: 12.5, color: 'var(--nb-risk)' }}>
            {submitError}
          </p>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            type="button"
            className="nb-btn nb-btn-ghost"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="nb-btn nb-btn-primary"
            onClick={() => void send()}
            disabled={submitting}
          >
            {submitting ? 'Sending…' : 'Send email'}
          </button>
        </div>
      </div>
    </SimpleModal>
  );
}
